export default __webpack_public_path__ + "static/media/treenvest1.a7aaaa95.png";